import { useCallback, useEffect, useState } from "react";

const ua = () => (typeof navigator === "undefined" ? "" : navigator.userAgent || "");
export const isAndroid = () => /Android/i.test(ua());
export const isIOS = () => /iPhone|iPad|iPod/i.test(ua()) || (/Macintosh/i.test(ua()) && navigator.maxTouchPoints > 1);
export const isStandalone = () =>
  (typeof window !== "undefined" && window.matchMedia?.("(display-mode: standalone)").matches) || navigator.standalone === true;
export const deviceKind = () => (isAndroid() ? "android" : isIOS() ? "ios" : "desktop");

// index.js stores the early `beforeinstallprompt` event on window.__pwaInstallEvent and re-dispatches "pwa-install-ready".
export function usePwaInstall() {
  const [promptEvent, setPromptEvent] = useState(() => window.__pwaInstallEvent || null);
  const [installed, setInstalled] = useState(() => isStandalone() || localStorage.getItem("pwa_installed") === "1");
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    const onReady = (e) => setPromptEvent(e.detail || window.__pwaInstallEvent || null);
    const onInstalled = () => { setInstalled(true); localStorage.setItem("pwa_installed", "1"); setPromptEvent(null); window.__pwaInstallEvent = null; };
    window.addEventListener("pwa-install-ready", onReady);
    window.addEventListener("appinstalled", onInstalled);
    return () => { window.removeEventListener("pwa-install-ready", onReady); window.removeEventListener("appinstalled", onInstalled); };
  }, []);

  const install = useCallback(async () => {
    if (!promptEvent) return "unavailable";
    setBusy(true);
    try {
      promptEvent.prompt();
      const choice = await promptEvent.userChoice;
      if (choice?.outcome === "accepted") { setInstalled(true); localStorage.setItem("pwa_installed", "1"); }
      setPromptEvent(null);
      window.__pwaInstallEvent = null;
      return choice?.outcome || "dismissed";
    } finally { setBusy(false); }
  }, [promptEvent]);

  return { canInstall: !!promptEvent && !installed, install, installed, busy, standalone: isStandalone(), device: deviceKind() };
}
